import { Product } from '../types';

export const isProductOutOfStock = (product?: Pick<Product, 'sin_stock_web'> | null) =>
    product?.sin_stock_web === true || product?.sin_stock_web === 1;

export const getProductStockLimit = (
    product?: Pick<Product, 'es_promocion' | 'stock_web_automatico' | 'stock_total' | 'stock_maximo_web'> | null
) => {
    if (!product) return null;
    if (product.stock_maximo_web !== null && product.stock_maximo_web !== undefined) {
        return Math.max(0, Math.floor(Number(product.stock_maximo_web) || 0));
    }
    if (product.es_promocion === true || product.es_promocion === 1) return null;
    const automatic = product.stock_web_automatico === true || product.stock_web_automatico === 1;
    if (!automatic) return null;
    return Math.max(0, Math.floor(Number(product.stock_total) || 0));
};

export const sortProductsByAvailability = <T extends Pick<Product, 'sin_stock_web'>>(products: T[]) =>
    products
        .map((product, index) => ({ product, index }))
        .sort((a, b) =>
            Number(isProductOutOfStock(a.product)) - Number(isProductOutOfStock(b.product))
            || a.index - b.index
        )
        .map(({ product }) => product);

export const getPreferredVariantId = (product: Product) => {
    const variants = product.variantes || [];
    if (variants.length <= 1) return product.idProductos;

    return variants.find(variant => !isProductOutOfStock(variant))?.idProductos
        ?? product.idProductos;
};


// Cada vista usa exclusivamente su propio campo de orden.
export const sortProductsByScope = (
    products: Product[], scope?: 'category' | 'subcategory'
): Product[] => {
    if (!scope) return sortProductsByAvailability(products);
    const field = scope === 'subcategory' ? 'orden_subcategoria' : 'orden';
    const ordered = [...products].sort((a, b) =>
        Number(a[field] ?? 0) - Number(b[field] ?? 0)
        || a.NombresProductos.localeCompare(b.NombresProductos)
        || a.idProductos - b.idProductos
    );
    return sortProductsByAvailability(ordered);
};
